export const GET_REASSIGNMENT = 'GET_REASSIGNMENT';
export const GET_REASSIGNMENT_SUCCESS = 'GET_REASSIGNMENT_SUCCESS';
export const GET_REASSIGNMENT_ERROR = 'GET_REASSIGNMENT_ERROR';

export const PATCH_REASSIGNMENT = 'PATCH_REASSIGNMENT';
export const PATCH_REASSIGNMENT_SUCCESS = 'PATCH_REASSIGNMENT_SUCCESS';
export const PATCH_REASSIGNMENT_ERROR = 'PATCH_REASSIGNMENT_ERROR';